import React from 'react';
import { motion } from 'framer-motion';
import s from './onboarding.module.scss';
import { Button } from '@shared/ui/button/button';
import { OnboardingVideo } from './ui/onboarding-video';
import { itemVariants, sectionVariants } from '@shared/lib/onboarding-motion';

const DESKTOP_URL = process.env.REACT_APP_STORAGE_URL + 'images/showreel-video/teacher-profile.mp4';
const MOBILE_URL = process.env.REACT_APP_STORAGE_URL + 'images/showreel-video/teacher-profile(mobile).mp4';

export const TeacherProfile = ({ setCurrentStep }) => {
	return (
		<motion.div className={s.slideWrapper} variants={sectionVariants} initial="initial" animate="animate">
			<motion.div className={s.titleWrapper} variants={itemVariants}>
				<p className={s.title}>Ваш профиль</p>
				<p className={s.subtitle}>
					Так ученики видят вашу карточку: отзывы, фото и видео, образование и пакеты занятий.
				</p>
			</motion.div>
			<motion.div variants={itemVariants}>
				<OnboardingVideo desktopUrl={DESKTOP_URL} mobileUrl={MOBILE_URL} />
			</motion.div>
			<motion.div className={s.btns} variants={itemVariants}>
				<Button
					label="Назад"
					size="small"
					theme="secondary"
					className={s.button}
					onClick={() => setCurrentStep((prev) => prev - 1)}
				/>
				<Button
					label="Далее"
					size="small"
					className={s.button}
					onClick={() => setCurrentStep((prev) => prev + 1)}
				/>
			</motion.div>
		</motion.div>
	);
};
